import { uniq } from 'lodash';

import { SLATE_EDITOR_ACTION } from 'src/lib/slate';

import { getEditorActionLabel, isTextStyleAction } from './editorAction';

const createOption = (editorAction) => ({
  value: editorAction,
  label: getEditorActionLabel(editorAction),
});

export const onlyTextStyleOptions = (editorActions) => editorActions.filter(isTextStyleAction);

/**
 * Prepare "text style" options for "select" component
 * @param {SLATE_EDITOR_ACTION[]} editorActions - list of available editor actions
 * @param {object} [options] - additional options
 * @returns {{label: *, value: *}[]} - list of "select" options
 */
export const prepareTextStyleOptions = (editorActions, options) => {
  // Take only "text style" actions from the full list of available actions
  const availableActions = onlyTextStyleOptions(editorActions);

  // Add default text style
  if (!options?.hideDefaultTextStyle) {
    availableActions.unshift(SLATE_EDITOR_ACTION.toggleParagraph);
  }

  // Remove duplicates (we might already had "paragraph" in there)
  const uniqActions = uniq(availableActions);

  return uniqActions.map(createOption);
};
